import * as React from 'react'

import { EXTRA_LARGE_ICON_BASE_SRC, } from '../../../Shared/index'

const researchBooksSrc = `${EXTRA_LARGE_ICON_BASE_SRC}/research-books.svg`

const baseImageLink = `${window.postbuildEnv.CDN_URL}/images/pages/premium`
const subscriberLogoBaseImageLink = `${baseImageLink}/subscriber_logos`

const teacherReportsSrc = `${baseImageLink}/illustrations-teacher-reports.svg`
const schoolDashboardSrc = `${baseImageLink}/illustrations-school-dashboard.svg`
const schoolSupportSrc = `${baseImageLink}/illustrations-school-support.svg`

const studentCompletingDiagnosticSrc = `${baseImageLink}/student-completing-diagnostic.webp`
const backwardsPlanningSrc = `${baseImageLink}/backwards-planning-book.webp`
const premiumReportLaptopSrc = `${baseImageLink}/premium-report-laptop.webp`

const erikaSrc = `${baseImageLink}/erika.webp`
const shannonSrc = `${baseImageLink}/shannon.webp`
const scarletSrc = `${baseImageLink}/scarlett.webp`

const subscriberInfo = [
  { name: 'Aiken County Public Schools', location: 'Aiken, SC', imgSrc: `${subscriberLogoBaseImageLink}/aiken_county_public_schools@2x.webp` },
  { name: 'Bryan ISD', location: 'Bryan, TX', imgSrc: `${subscriberLogoBaseImageLink}/bryan_isd@2x.webp` },
  { name: 'Calcasieu Parish ', location: 'Lake Charles, LA', imgSrc: `${subscriberLogoBaseImageLink}/calcasieu_parish@2x.webp` },
  { name: 'Edmond Public Schools', location: 'Edmond, OK', imgSrc: `${subscriberLogoBaseImageLink}/edmond_public_schools@2x.webp` },
  { name: 'Fayette County School District', location: 'Aiken, SC', imgSrc: `${subscriberLogoBaseImageLink}/fayette_county_public_schools@2x.webp` },
  { name: 'Hawaii Department of Education', location: 'Honolulu, HI', imgSrc: `${subscriberLogoBaseImageLink}/hawaii_department_of_education@2x.webp` },
  { name: 'Indian Prairie School District', location: 'DuPage County / Will County, IL', imgSrc: `${subscriberLogoBaseImageLink}/indian_prairie_school_district@2x.webp` },
  { name: 'Katy ISD', location: 'Katy, TX', imgSrc: `${subscriberLogoBaseImageLink}/katy_isd@2x.webp` },
  { name: 'KIPP NJ', location: 'Newark, NJ', imgSrc: `${subscriberLogoBaseImageLink}/kipp_nj@2x.webp` },
  { name: 'Los Angeles Unified SD', location: 'Los Angeles, CA', imgSrc: `${subscriberLogoBaseImageLink}/los_angeles_unified_sd@2x.webp` },
  { name: 'Mastery Charter Schools', location: 'Philadelphia, PA / Camden, NJ', imgSrc: `${subscriberLogoBaseImageLink}/mastery_charter_schools@2x.webp` },
  { name: 'Morris School District', location: 'Morristown, NJ', imgSrc: `${subscriberLogoBaseImageLink}/morris_school_district@2x.webp` },
  { name: 'Plainfield SD 202', location: 'Plainfield, IL', imgSrc: `${subscriberLogoBaseImageLink}/plainfield_sd_202@2x.webp` },
  { name: 'Saint Croix School District', location: 'Saint Croix, Virgin Islands', imgSrc: `${subscriberLogoBaseImageLink}/saint_croix_school_district@2x.webp` },
  { name: 'Waterbury Public School District', location: 'Waterbury, CT', imgSrc: `${subscriberLogoBaseImageLink}/waterbury_public_school_district@2x.webp` },
]

const PremiumFeature = ({ imageSrc, imageAlt, header, text, subheader, useLevelThreeSubheader}) => (
  <div className="premium-feature">
    <div className="image-wrapper">
      <img alt={imageAlt} src={imageSrc} />
    </div>
    {header && (useLevelThreeSubheader ? <h3 className="premium-feature-header">{header}</h3> : <h4 className="premium-feature-header">{header}</h4>)}
    {subheader}
    <p>{text}</p>
  </div>
)

const TopicExplored = ({color, imgSrc, text}) => (
  <div className="topic-explored">
    <div className="topic-image">
      <img alt="" src={imgSrc} />
    </div>
    <h4 className={color}>{text}</h4>
  </div>
)

const coachingTeam = (
  <section className="premium-page-section coaching-team-section">
    <h2 className="premium-page-section-header">Quill’s Implementation Team Enables Districtwide Success</h2>
    <p className="premium-page-section-subheader">The Quill team is by your side every step of the way to strengthen student writing and build confident, effective educators. We offer customized training aligned to your school or district priorities, helping teachers deepen their expertise in both Quill’s tools and writing instruction. With flexible virtual and on-demand options, plus priority support and a dedicated implementation manager, you’ll always have the guidance you need.</p>
    <div className="premium-features-row">
      <PremiumFeature
        header="Erika Parker-Havens"
        imageAlt="Photograph of Quill's coach, Erika"
        imageSrc={erikaSrc}
        subheader={[<span key="years">15+ years in Education</span>, <span key="title">Former MS English teacher and Academic Dean</span>]}
        text="Expert in culturally responsive teaching practices, writing in the content areas and helping teachers practically use tools to facilitate learning through writing"
        useLevelThreeSubheader={true}
      />
      <PremiumFeature
        header="Scarlet Melo"
        imageAlt="Photograph of Quill's coach, Scarlet"
        imageSrc={scarletSrc}
        subheader={[<span key="years">8+ years in education</span>, <span key="title">Former HS teacher and Academic Tutor</span>]}
        text="Expert in writing instruction and supporting multilingual learners through culturally responsive, tech-integrated strategies"
        useLevelThreeSubheader={true}
      />
      <PremiumFeature
        header="Shannon Browne"
        imageAlt="Photograph of Quill's coach, Shannon"
        imageSrc={shannonSrc}
        subheader={[<span key="years">15+ years in Education</span>, <span key="title">Former HS English Teacher and Director of Instruction</span>]}
        text="Expert in data-informed instructional strategies and prioritizing the needs of special populations in writing practice routines"
        useLevelThreeSubheader={true}
      />
    </div>
  </section>
)

const actionableFeaturesAndSupport = (
  <section className="premium-page-section unlock-reporting-and-support">
    <h3 className="premium-page-section-header">Unlock Reporting and Support with Premium</h3>
    <p className="premium-page-section-subheader">We offer School Premium site licenses that provide access for all teachers at a school to both our free and teacher premium features. In addition, we offer school-wide professional development, administrative oversight and reporting, and individualized, ongoing support from our School Partnerships team.</p>
    <div className="premium-features-row">
      <PremiumFeature
        header="Teacher reports"
        imageAlt="Example dashboard showing multiple teacher reports"
        imageSrc={teacherReportsSrc}
        text="Access each classroom’s Quill Premium reports. Print and download progress reports on concepts and standards mastered."
      />
      <PremiumFeature
        header="School administrator dashboard"
        imageAlt="Example PremiumHub showing multiple teacher dashboards with student results"
        imageSrc={schoolDashboardSrc}
        text="Access each teacher's Premium account to assign activities, manage rosters and view data. Access school-level reports to see rolled up data at the school level."
      />
      <PremiumFeature
        header="School-wide educator support"
        imageAlt="A school with a person giving a presentation and another person teaching"
        imageSrc={schoolSupportSrc}
        text="Access customized training and professional development webinars, instructional coaching sessions, and individualized reporting, all provided by our dedicated School Partnerships team."
      />
    </div>
  </section>
)

const professionalDevelopmentSessions = (
  <section className="premium-page-section professional-development-sessions">
    <h3 className="premium-page-section-header">Professional Development Sessions</h3>
    <p className="premium-page-section-subheader">Quill Premium for schools and districts includes live virtual workshop-style training and an asynchronous course library.</p>
    <div className="premium-features-row">
      <PremiumFeature
        imageAlt="A student focusing on his laptop while working on Quill Diagnostic"
        imageSrc={studentCompletingDiagnosticSrc}
        text="Flexible and comprehensive training that fits your schedule with virtual and on-demand formats"
      />
      <PremiumFeature
        imageAlt="A photograph of the book, Writing for Understanding"
        imageSrc={backwardsPlanningSrc}
        text="A focus on instructional best practices and practical application with workshop-style training"
      />
      <PremiumFeature
        imageAlt="A person typing on a laptop with a Quill Premium report on the screen"
        imageSrc={premiumReportLaptopSrc}
        text="Support for educators that strengthens both pedagogical and Quill skills"
      />
    </div>
  </section>
)

const topicsExplored = (
  <section className="premium-page-section">
    <h3 className="premium-page-section-header">Quill Provides More Than 15 Different Courses For Educators, <br />Covering Topics Such As:</h3>
    <div className="topics-wrapper">
      <TopicExplored color="quill-blue" imgSrc={`${baseImageLink}/globe.svg`} text="Supporting English language learners" />
      <TopicExplored color="quill-violet" imgSrc={`${baseImageLink}/hat-3.svg`} text="Supporting exceptional learners" />
      <TopicExplored color="quill-teal" imgSrc={`${baseImageLink}/grammar-check.svg`} text="Data instruction" />
      <TopicExplored color="quill-gold-dark" imgSrc={`${baseImageLink}/frame.svg`} text="Improving sentence fluency" />
      <TopicExplored color="quill-red" imgSrc={`${baseImageLink}/student-pencil.svg`} text="Backward planning" />
      <TopicExplored color="quill-green" imgSrc={`${baseImageLink}/quill.svg`} text="Leveraging Quill's tools and activities" />
      <TopicExplored color="quill-maroon" imgSrc={`${baseImageLink}/code-editor.svg`} text="Impactful feedback practices" />
      <TopicExplored color="quill-purple" imgSrc={`${baseImageLink}/add-students.svg`} text="Empowering student writers" />
      <TopicExplored color="quill-blue" imgSrc={`${baseImageLink}/teacher-chalkboard.svg`} text="Writing across content areas" />
    </div>
  </section>
)

const testimonials = (
  <section className="premium-page-section">
    <h3 className="premium-page-section-header">What Are People Saying?</h3>
    <div className="premium-features-row testimonials-wrapper">
      <div className="testimonial long">
        <p>Totally personalized! I told the Quill coach my background and what my familiarity with Quill was, and she was able to walk me through exactly what I needed. Also appreciate that she could show me with her screen, walking through my classes with me.</p>
        <span>Teacher, Glacier View Junior High School</span>
      </div>
      <div className="testimonial">
        <p>I appreciated the time given to analyze our own data while in the training.</p>
        <span>Teacher, Meeting Street Elementary at Burns</span>
      </div>
      <div className="testimonial">
        <p>Our Quill coach is a really engaging facilitator! I appreciated her expertise and the built-in work time.</p>
        <span>Director of Academics, Thurgood Marshall</span>
      </div>
      <div className="testimonial">
        <p>I appreciated the facilitator&#39;s responsiveness to the needs specific to our network. I also appreciate the thoughtfulness of applying Quill remotely.</p>
        <span>Administrator, Mastery Charter Schools</span>
      </div>
      <div className="testimonial">
        <p>Our Quill coach was very knowledgeable and friendly. I felt as though I could ask her anything and there would be no judgement!!</p>
        <span>Teacher, Union High School</span>
      </div>
    </div>
  </section>
)

const subscribers = (
  <section className="premium-page-section subscribers-section">
    <h3 className="premium-page-section-header">Trusted By Some Of The Best Schools</h3>
    <div className="premium-features-row">
      {subscriberInfo.map((subscriber) => (
        <PremiumFeature
          header={subscriber.name}
          imageAlt={`${subscriber.name} logo`}
          imageSrc={subscriber.imgSrc}
          key={subscriber.name}
          subheader={<span>{subscriber.location}</span>}
        />
      ))}
    </div>
  </section>
)

const SchoolPremium = () => {
  return(
    <div className='container premium-features school text-center' id="school-premium">
      <section className='premium-features-header'>
        <div className="img-holder">
          <img alt="" src={researchBooksSrc} />
        </div>
        <h2>School and District Premium</h2>
        <p>We offer School Premium site licenses that provide access for all teachers at a school to both our free and teacher premium features. In addition, we offer school-wide professional development, administrative oversight and reporting, and individualized, ongoing support from our School Partnerships team.</p>
        {actionableFeaturesAndSupport}
      </section>
      <div className='premium-features-body'>
        {coachingTeam}
        {professionalDevelopmentSessions}
        {topicsExplored}
        {testimonials}
        {/*
          TODO: uncomment this out when we have the final list of districts that have approved their use here
          {subscribers}
        */}
      </div>
    </div>
  );
};

export default SchoolPremium;

SchoolPremium.displayName = 'SchoolPremium'
